import React,{useRef} from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import classes from './BrandCarousel.module.css'
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination,Autoplay} from 'swiper/modules';
import brand_logo1 from "../Assets/Images/brand/brand_logo01.png";
import brand_logo2 from "../Assets/Images/brand/brand_logo02.png";
import brand_logo3 from "../Assets/Images/brand/brand_logo03.png";
import brand_logo4 from "../Assets/Images/brand/brand_logo04.png";
import brand_logo5 from "../Assets/Images/brand/brand_logo05.png";
import brand_logo6 from "../Assets/Images/brand/brand_logo06.png";


const BrandCarousel = () => {

    const swiperRef = useRef(null);


    const images = [
      {img:brand_logo1},
      {img:brand_logo2},
      {img:brand_logo3},
      {img:brand_logo4},
      {img:brand_logo5},
      {img:brand_logo6},
  ]


    // console.log(images)

  return (
    <div className={classes.container}>
    <Swiper
      slidesPerView={3}
      spaceBetween={30}
      ref={swiperRef}
      loop={true}
      autoplay={{
        delay: 2000, // Time in milliseconds between slides
        disableOnInteraction: false, // Keeps autoplay running even after interaction
      }}
      spaceBetween={5}
      className="mySwiper"
     
      breakpoints={{
    // Small devices (mobile phones, 640px and down)
        576: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        // Medium devices (tablets, 768px and up)
        768: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        // Large devices (desktops, 1024px and up)
        1024: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        // Extra large devices (1200px and up)
        1200: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      }}
      modules={[Pagination,Autoplay]}
      onSwiper={(swiper) => (swiperRef.current = swiper)}
     

    >
      {
        images?.map((item,idx)=>(
          <SwiperSlide className={classes.slide} key={idx}>
        <img src={item.img} alt="" className={classes.img} loading = "lazy" />
      </SwiperSlide>
        ))
      }
      
    </Swiper>
    </div>
  )
}

export default BrandCarousel
